import toMap from "~/misc/toMap";
import { POSTTRUCKSHOWTYPE } from "../utils";

export const ACTIONTYPE = toMap([
  "ADD_POSTTRUCK",
  "DELETE_POSTTRUCK",
  "EDIT_POSTTRUCK",
  "CHANGE_SHOWCARD",
  "SELECTEDPOSTTRUCK",
  "SETRATE",
]);

const init = () => {
  return {
    addPostTruck: {},
    deletePostTruck: {},
    updatePostTruck: {},
    selectedPostTruck: null,
    rate: "",
    showCard: POSTTRUCKSHOWTYPE.LIST, // POSTTRUCKSHOWTYPE.LIST,DETAIL_CREATE
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONTYPE.ADD_POSTTRUCK:
      if (action.error || action.pending) return state;
      return {
        addPostTruck: action.payload,
      };
    case ACTIONTYPE.DELETE_POSTTRUCK:
      if (action.error || action.pending) return state;
      return {
        deletePostTruck: action.payload,
      };
    case ACTIONTYPE.EDIT_POSTTRUCK:
      if (action.error || action.pending) return state;
      return {
        addPostTruck: action.payload,
      };
    case ACTIONTYPE.CHANGE_SHOWCARD:
      if (action.error || action.pending) return state;
      return {
        showCard: action.payload,
      };
    case ACTIONTYPE.SELECTEDPOSTTRUCK:
      if (action.error || action.pending) return state;
      return {
        selectedPostTruck: action.payload,
      };
    case ACTIONTYPE.SETRATE:
      if (action.error || action.pending) return state;
      return {
        rate: action.payload,
      };
    default:
      break;
  }
  return null;
};

export default { reducer, init };



// WEBPACK FOOTER //
// ./src/pages/PostTruck/state/reducer.js